/* Article: rte wrappers + table of contents (moved from sections/innovist-article.liquid). */
(function () {
  function init(root) {
    if (!root || root.dataset.tocReady === 'true') return;
    root.dataset.tocReady = 'true';

    var articleRoot = root.querySelector('[data-article-rte]');
    var toc = root.querySelector('[data-article-toc]');
    var tocList = root.querySelector('[data-article-toc-list]');
    if (!articleRoot || !toc || !tocList) return;

    // Innovist's at-rte behaviour: scrollable tables, responsive videos, no underline on image links.
    articleRoot.querySelectorAll('table').forEach(function (table) {
      if (table.parentNode.classList.contains('table-wrapper')) return;
      var wrap = document.createElement('div');
      wrap.className = 'table-wrapper';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
    articleRoot.querySelectorAll('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]').forEach(function (iframe) {
      var wrap = document.createElement('div');
      wrap.className = 'video-wrapper';
      iframe.parentNode.insertBefore(wrap, iframe);
      wrap.appendChild(iframe);
    });
    articleRoot.querySelectorAll('a img').forEach(function (img) {
      img.parentNode.classList.add('rte__image');
    });

    var headings = articleRoot.querySelectorAll('h2');
    if (!headings.length) return;

    function slugify(text) {
      return text
        .toLowerCase()
        .trim()
        .replace(/<\/?[^>]+(>|$)/g, '')
        .replace(/&[a-z]+;/g, '')
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    }

    var used = Object.create(null);

    headings.forEach(function (h2, idx) {
      var title = (h2.textContent || '').trim();
      if (!title) return;

      var base = slugify(title) || 'section-' + (idx + 1);
      var id = base;
      var n = 2;
      while (used[id] || document.getElementById(id)) {
        id = base + '-' + n++;
      }
      used[id] = true;

      if (!h2.id) h2.id = id;

      var li = document.createElement('li');
      li.className = 'article-toc__item';
      var a = document.createElement('a');
      a.className = 'article-toc__link';
      a.href = '#' + h2.id;
      a.textContent = title;
      li.appendChild(a);
      tocList.appendChild(li);
    });

    if (tocList.children.length) toc.style.display = '';

    // Scroll with 200px top offset (Innovist behaviour).
    toc.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link) return;
      var targetId = link.getAttribute('href').slice(1);
      var target = document.getElementById(targetId);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 200;
      window.scrollTo({ top: top, behavior: 'smooth' });
      history.replaceState(null, '', '#' + targetId);
    });
  }

  function initAll() { document.querySelectorAll('.inv-article').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
